import React, { useEffect, useState } from 'react';
import { Modal, Input } from 'antd';
import { useTranslation } from 'react-i18next';

interface ZipFolderModalProps {
  visible: boolean;
  defaultName?: string;
  onOk: (zipName: string) => void;
  onCancel: () => void;
}

const ZipFolderModal: React.FC<ZipFolderModalProps> = ({
  visible,
  defaultName = 'archiv',
  onOk,
  onCancel,
}) => {
  //#region ------------------------------ States / Attributes / Selectors
  const { t } = useTranslation();
  const [zipName, setZipName] = useState(defaultName);
  //#endregion

  //#region ------------------------------ Methods / Handlers
  const handleCancel = (event?: React.MouseEvent<HTMLElement>) => {
    event?.preventDefault();
    event?.stopPropagation();
    onCancel();
  };

  const handleOk = (event?: React.MouseEvent<HTMLElement>) => {
    event?.preventDefault();
    event?.stopPropagation();
    onOk(zipName || defaultName);
  };
  //#endregion

  //#region ------------------------------ Effects
  useEffect(() => {
    if (visible) {
      setZipName(defaultName);
    }
  }, [visible, defaultName]);
  //#endregion

  return (
    <Modal
      title={t(
        'documents:navigationBar.modals.zip.title',
        'Ordner komprimieren'
      )}
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={t('documents:navigationBar.modals.zip.okText')}
      cancelText={t('documents:navigationBar.modals.zip.cancelText')}
      closable
    >
      <Input
        value={zipName}
        onChange={(e) => setZipName(e.target.value)}
        placeholder={t(
          'documents:navigationBar.modals.zip.placeholder',
          'Name des Archivs'
        )}
        maxLength={128}
        autoFocus
      />
    </Modal>
  );
};

export default ZipFolderModal;
